import React from 'react'
import './MontoVenta.css'
import Icon from 'src/shared/icons'
import { TotalVentas } from '../../ArticulosVendidos.type'
import { sum } from 'src/shared/helpers/calculator'
import { formatCurrencyToFixed } from 'src/shared/hooks/formatCurrency'

const MontoVenta = ({totalVentas}: {totalVentas: TotalVentas}) => {
    return (
        <div className='articulos-vendidos__card'>
            <div className='monto-venta__container'>
                <div className='monto-venta__item'>
                    <span className='monto-venta__text--bold'>Monto de venta</span>
                </div>
            </div>
            <div className='monto-venta__container__wrapper'>
                <div className='monto-venta__container'>
                    <div className='monto-venta__item'>
                        <span className='monto-venta__text'> <Icon width={13} height={13} name='dollarCircle' color='var(--primary)' />Total de venta</span>
                        <span className='monto-venta__text--bold'>{formatCurrencyToFixed(sum([Number(totalVentas?.mostrador || 0), Number(totalVentas?.restaurante || 0), Number(totalVentas?.room_service || 0)]))}</span>
                    </div>
                    <div className='monto-venta__item'>
                        <span className='monto-venta__text'> <Icon width={13} height={13} name='restaurantFill' color='var(--primary)' />Total room service</span>
                        <span className='monto-venta__text--bold'>{formatCurrencyToFixed(Number(totalVentas?.room_service) || 0)}</span>
                    </div>
                    <div className='monto-venta__item'>
                        <span className='monto-venta__text'> <Icon width={13} height={13} name='Keynote' color='var(--primary)' />Total restaurante</span>
                        <span className='monto-venta__text--bold'>{formatCurrencyToFixed(Number(totalVentas?.restaurante) || 0)}</span>
                    </div>
                    <div className='monto-venta__item'>
                        <span className='monto-venta__text'> <Icon width={13} height={13} name='Order' color='var(--primary)' />Total mostrador</span>
                        <span className='monto-venta__text--bold'>{formatCurrencyToFixed(Number(totalVentas?.mostrador) || 0)}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MontoVenta